import BlogArticleLayout from '@/components/feature/BlogArticleLayout';

export default function ErrosComunsPage() {
  return <BlogArticleLayout slug="erros-comuns-compras-china" />;
}